import request from '../request';

/**
 * 获取微心愿列表
 * @param {Object} params - 查询参数
 * @param {Number} params.page - 页码
 * @param {Number} params.pageSize - 每页数量
 * @param {Number} params.wishStat - 状态 (例如：0-未领取 1-已领取 等)
 * @returns {Promise}
 */
export function getWishList(data) {
  return request({
    url: '/app/wish/list',
    method: 'post',
    data
  });
}

/**
 * 获取微心愿详情
 * @param {Object} params - 查询参数
 * @param {Number} params.id - 心愿ID
 * @returns {Promise}
 */
export function getWishInfo(params) {
  return request({
    url: '/app/wish/info',
    method: 'get',
    params
  });
}

/**
 * 领取微心愿
 * @param {Object} params - 查询参数
 * @param {Number} params.wishId - 心愿ID
 * @returns {Promise}
 */
export function pickWish(params) {
  return request({
    url: '/app/wish/picker',
    method: 'get',
    params
  });
}

/**
 * 提交微心愿完成情况
 * @param {Object} data - 提交数据
 * @param {Number} data.id - 心愿ID
 * @param {String} data.finishedContent - 完成说明
 * @param {Array} data.finishedImgUrl - 完成图片
 * @returns {Promise}
 */
export function finishWish(data) {
  return request({
    url: '/app/wish/finish',
    method: 'post',
    data
  });
}
